import React, { useEffect } from "react";

const Chameleon = () => {
  function getColor() {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);

    const color = `rgb(${r}, ${g}, ${b})`;

    const chameleonColor = document.querySelector(".chameleon-container");
    chameleonColor.style.background = color;
  }
  useEffect(getColor);

  return (
    <div>
      <div className="page-container-chameleon">
        <div className="title-container">
          Cliquez sur l'image pour changer la couleur du caméléon
        </div>
        <span
          onClick={getColor}
          rel="noopener noreferrer"
          className="chameleon-container hover"
        >
          <img src="./assets/img/chameleon.png" alt="Caméléon" />
        </span>
      </div>
    </div>
  );
};

export default Chameleon;

// https://fr.legacy.reactjs.org/docs/handling-events.html
